import React from "react";
import ReactDom from "react-dom";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import Application from "./Application";
import {SENTRY_DSN} from "~/config";
import {applicationUpdated, requestUserConfirmApplicationUpdate} from "~/components/AppUpdate";
import {Workbox} from 'workbox-window';


Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
});

ReactDom.render(React.createElement(Application), document.getElementById("root"));


// для удаления всех сервис воркеров клиентов, можно разместить скрипт разрегистрации всех воркеров в index.html
if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        const wb = new Workbox("/service-worker.js");
        // @ts-ignore
        window.wb = wb;

        wb.addEventListener("controlling", () => {
            applicationUpdated();
        })

        wb.addEventListener("waiting", async (event) => {
            try {
                const reactRenderError = document.getElementById("root").children.length == 0;
                if (reactRenderError) {
                    wb.messageSkipWaiting();
                    window.location.reload();
                } else {
                    const confirmed = await requestUserConfirmApplicationUpdate()
                    if (confirmed) {
                        wb.messageSkipWaiting();
                    }
                }
            } catch (e) {
                console.error("Force skip waiting");
                wb.messageSkipWaiting();
            }
        })

        wb.register().then(() => {
            const checkUpdate = () => {
                console.log("Check update service worker!");
                wb.update().then(() => {
                    setTimeout(checkUpdate, 1000 * 60);
                })
            }
            checkUpdate();
        }).catch(e => {
            console.error("Register service worker error", e);
        });
    });
}